// src/components/SignUp.jsx
import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Safe COLORS (si existe constants/ui lo usa, si no, no rompe)
let COLORS_SAFE = {};
try {
  // eslint-disable-next-line global-require
  COLORS_SAFE = require("../constants/ui").COLORS || {};
} catch {
  COLORS_SAFE = {};
}

const GlobalSignUpCSS = () => (
  <style>{`
    :root{
      --text: #0f172a;
      --muted: rgba(15,23,42,.72);
      --accent: #06b6d4;
      --accent2:#2563eb;
      --ring: rgba(6,182,212,.35);
      --border: rgba(255,255,255,.22);
      --shadow: 0 18px 50px rgba(2,6,23,.18);
    }

    html, body, #root{ height:100%; }
    body{
      margin:0;
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
    }

    .vh{
      min-height: 100vh;
      min-height: 100svh;
      min-height: 100dvh;
    }

    .page-root{
      position: relative;
      overflow: hidden;
    }

    /* Background slider */
    .bg-slider{
      position:absolute;
      inset:0;
      z-index:0;
    }
    .bg-slider .slick-slider,
    .bg-slider .slick-list,
    .bg-slider .slick-track,
    .bg-slider .slick-slide > div{
      height: 100%;
    }

    .bg-slide{ position:relative; width:100%; height:100%; }
    .bg-img{
      width:100%;
      height:100%;
      object-fit: cover;
      transform: scale(1.04);
      filter: saturate(1.05) contrast(1.02);
    }

    .bg-overlay{
      position:absolute;
      inset:0;
      background:
        radial-gradient(900px 600px at 12% 10%, rgba(37,99,235,.25), transparent 55%),
        radial-gradient(900px 600px at 88% 12%, rgba(6,182,212,.28), transparent 50%),
        radial-gradient(900px 600px at 30% 90%, rgba(99,102,241,.18), transparent 55%),
        linear-gradient(180deg, rgba(0,0,0,.35), rgba(0,0,0,.62));
    }

    .content{
      position: relative;
      z-index:2;
      height:100%;
      display:grid;
      align-items:center;
      padding: clamp(14px, 3.5vw, 36px);
    }

    .wrap{
      width: min(980px, 92vw);
      margin: 0 auto;
    }

    .grid{
      display:grid;
      gap: clamp(12px, 2.6vw, 22px);
      grid-template-columns: 1.05fr .95fr;
      align-items: start;
    }
    @media (max-width: 980px){
      .grid{ grid-template-columns: 1fr; }
    }

    .card{
      background: rgba(255,255,255,.14);
      border: 1px solid var(--border);
      border-radius: 22px;
      box-shadow: var(--shadow);
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
      padding: clamp(14px, 3.2vw, 28px);
      color:#fff;
    }

    .brand{
      display:flex;
      align-items:center;
      gap: 12px;
      margin-bottom: 10px;
    }

    .logo{
      width: 44px;
      height: 44px;
      border-radius: 14px;
      background: rgba(255,255,255,.18);
      border: 1px solid rgba(255,255,255,.22);
      display:flex;
      align-items:center;
      justify-content:center;
      overflow:hidden;
      flex: 0 0 auto;
    }
    .logo img{ width:100%; height:100%; object-fit:cover; }

    .title{
      margin: 0;
      font-size: clamp(22px, 4.2vw, 40px);
      font-weight: 900;
      letter-spacing: .2px;
      line-height: 1.08;
    }
    .title span{
      background: linear-gradient(90deg, var(--accent2), var(--accent));
      -webkit-background-clip:text;
      background-clip:text;
      color: transparent;
    }

    .lead{
      margin: 10px 0 0;
      font-size: clamp(14px, 1.9vw, 17px);
      line-height: 1.75;
      color: rgba(255,255,255,.88);
      max-width: 72ch;
    }

    .form{
      margin-top: 14px;
      display:grid;
      gap: 10px;
    }

    .label{
      font-weight: 900;
      font-size: 12px;
      color: rgba(255,255,255,.78);
      margin-bottom: 4px;
    }

    .input{
      width: 100%;
      border-radius: 14px;
      border: 1px solid rgba(255,255,255,.22);
      background: rgba(255,255,255,.12);
      padding: 12px 12px;
      font-size: 15px;
      outline: none;
      color: #fff;
      box-sizing: border-box;
    }
    .input::placeholder{ color: rgba(255,255,255,.65); }
    .input:focus{
      box-shadow: 0 0 0 4px var(--ring);
      border-color: rgba(6,182,212,.55);
    }

    .row2{
      display:grid;
      gap: 10px;
      grid-template-columns: 1fr 1fr;
    }
    @media (max-width: 560px){
      .row2{ grid-template-columns: 1fr; }
    }

    .cta-row{
      display:flex;
      gap: 12px;
      flex-wrap: wrap;
      margin-top: 12px;
    }

    .btn{
      cursor:pointer;
      border: 0;
      border-radius: 14px;
      padding: 12px 14px;
      font-weight: 900;
      transition: transform .12s ease, filter .2s ease, opacity .2s ease;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      gap: 10px;
      user-select: none;
      white-space: nowrap;
      text-decoration:none;
    }
    .btn:active{ transform: translateY(1px); }
    .btn:hover{ filter: brightness(1.05); }
    .btn:disabled{ opacity:.6; cursor:not-allowed; }

    .btn-primary{
      background: linear-gradient(180deg, rgba(6,182,212,1), rgba(37,99,235,1));
      color:#062028;
      box-shadow: 0 12px 30px rgba(6,182,212,.18);
    }
    .btn-ghost{
      background: rgba(255,255,255,.14);
      color:#fff;
      border: 1px solid rgba(255,255,255,.22);
    }

    @media (max-width: 560px){
      .btn{ width:100%; }
      .cta-row{ gap: 10px; }
    }

    .msg{
      margin-top: 10px;
      font-weight: 900;
      padding: 10px 12px;
      border-radius: 14px;
      border: 1px solid rgba(255,255,255,.20);
      background: rgba(0,0,0,.18);
    }
    .msg.ok{ border-color: rgba(34,197,94,.30); }
    .msg.err{ border-color: rgba(239,68,68,.30); }

    .side{
      display:grid;
      gap: 12px;
    }
    .sideCard{
      background: rgba(255,255,255,.12);
      border: 1px solid rgba(255,255,255,.20);
      border-radius: 18px;
      padding: 14px 14px;
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
      color:#fff;
    }
    .sideTitle{ font-weight: 900; margin:0; font-size: 15px; }
    .sideText{
      margin: 6px 0 0;
      font-size: 13px;
      color: rgba(255,255,255,.84);
      line-height: 1.6;
    }

    /* slick dots/arrows */
    .bg-slider .slick-dots{ bottom: 16px; z-index: 6; }
    .bg-slider .slick-dots li button:before{
      color: rgba(255,255,255,.62);
      opacity: 1;
      font-size: 10px;
    }
    .bg-slider .slick-dots li.slick-active button:before{
      color: rgba(6,182,212,1);
    }

    .bg-slider .slick-prev, .bg-slider .slick-next{
      z-index: 7;
      width: 44px;
      height: 44px;
      border-radius: 999px;
      background: rgba(255,255,255,.16);
      border: 1px solid rgba(255,255,255,.22);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
    }
    .bg-slider .slick-prev{ left: 16px; }
    .bg-slider .slick-next{ right: 16px; }
    .bg-slider .slick-prev:before, .bg-slider .slick-next:before{
      color: rgba(255,255,255,.92);
      opacity: 1;
      font-size: 20px;
    }

    @media (max-width: 560px){
      .bg-slider .slick-prev,
      .bg-slider .slick-next{ display:none !important; }
      .bg-slider .slick-dots{ bottom: 10px; }
    }

    @media (max-height: 680px){
      .content{
        align-items: start;
        padding-top: 14px;
        padding-bottom: 38px;
      }
      .wrap{ padding-bottom: 18px; }
    }
  `}</style>
);

export default function SignUp() {
  const navigate = useNavigate();
  const accent = COLORS_SAFE?.accent || "#06b6d4";

  const [form, setForm] = useState({ username: "", email: "", password: "" });
  const [msg, setMsg] = useState({ type: "", text: "" });

  const slides = useMemo(
    () => [
      {
        src: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?fm=jpg&q=60&w=2400&ixlib=rb-4.0.3",
        alt: "Ciudad y tráfico",
      },
      {
        src: "https://as2.ftcdn.net/v2/jpg/02/70/19/17/1000_F_270191793_5Nk3dvcKjuUgCuNJZ4tzL5tTNsjQlkqh.jpg",
        alt: "Rutas urbanas",
      },
      {
        src: "https://kudeko.com/cdn/shop/products/cuadro-nueva-york-ciudad-sin-marco-fotografia-blanco-negro_800x.jpg?v=1666951353",
        alt: "Ciudad nocturna",
      },
    ],
    []
  );

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4200,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: true,
      touchMove: true,
      adaptiveHeight: false,
    }),
    []
  );

  const submit = (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });

    const u = form.username.trim().toLowerCase();
    const email = form.email.trim();
    const pass = form.password.trim();

    if (!u) return setMsg({ type: "err", text: "Escribe un usuario." });
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return setMsg({ type: "err", text: "Escribe un email válido." });
    }
    if (pass.length < 6) {
      return setMsg({ type: "err", text: "Contraseña mínima 6 caracteres." });
    }

    // ✅ Demo: crear cuenta (para producción: Firebase Auth)
    localStorage.setItem("username", u);
    localStorage.setItem("email", email);

    // ✅ clave para “Mi Pago”: meses desde creación de cuenta
    const createdAtMs = Number(localStorage.getItem("createdAtMs") || 0);
    if (!createdAtMs) localStorage.setItem("createdAtMs", String(Date.now()));

    setMsg({ type: "ok", text: "Cuenta creada. Entrando..." });
    navigate("/socio");
  };

  return (
    <>
      <GlobalSignUpCSS />

      <div className="page-root vh">
        {/* Fondo */}
        <div className="bg-slider" aria-hidden="true">
          <Slider {...settings}>
            {slides.map((s, i) => (
              <div key={i}>
                <div className="bg-slide">
                  <img className="bg-img" src={s.src} alt={s.alt || "Slide"} />
                  <div className="bg-overlay" />
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Contenido */}
        <div className="content">
          <div className="wrap">
            <div className="grid">
              <div className="card">
                <div className="brand">
                  <div className="logo">
                    <img src="/screen-do-logo.png" alt="Screen DO" />
                  </div>
                  <div>
                    <div style={{ fontWeight: 900, color: "rgba(255,255,255,.92)" }}>
                      Screen DO
                    </div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,.78)" }}>
                      Registro de Socios • Acceso seguro
                    </div>
                  </div>
                </div>

                <h1 className="title">
                  Crear <span>cuenta</span>
                </h1>

                <p className="lead">
                  Regístrate para acceder a tu panel y ver tu información. Luego podrás revisar{" "}
                  <strong style={{ color: accent }}>Mi Pago</strong> cuando esté disponible.
                </p>

                <form className="form" onSubmit={submit}>
                  <div>
                    <div className="label">Usuario</div>
                    <input
                      className="input"
                      placeholder="Ej: conductor123"
                      value={form.username}
                      onChange={(e) => setForm({ ...form, username: e.target.value })}
                      autoComplete="username"
                    />
                  </div>

                  <div className="row2">
                    <div>
                      <div className="label">Email</div>
                      <input
                        className="input"
                        placeholder="tu@email.com"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        autoComplete="email"
                      />
                    </div>
                    <div>
                      <div className="label">Contraseña</div>
                      <input
                        className="input"
                        placeholder="mínimo 6 caracteres"
                        type="password"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        autoComplete="new-password"
                      />
                    </div>
                  </div>

                  <div className="cta-row">
                    <button className="btn btn-primary" type="submit">
                      ✅ Crear cuenta
                    </button>

                    <Link className="btn btn-ghost" to="/login">
                      🔑 Ya tengo cuenta
                    </Link>

                    <Link className="btn btn-ghost" to="/">
                      🏠 Volver
                    </Link>
                  </div>
                </form>

                {msg.text && <div className={`msg ${msg.type}`}>{msg.text}</div>}
              </div>

              <div className="side">
                <div className="sideCard">
                  <p className="sideTitle">📅 Meses automáticos</p>
                  <p className="sideText">
                    Guardamos la fecha de creación para que “Mi Pago” genere los meses desde tu registro.
                  </p>
                </div>
                <div className="sideCard">
                  <p className="sideTitle">🔒 Acceso seguro</p>
                  <p className="sideText">
                    Este es modo demo con LocalStorage. Luego lo conectamos a Firebase Auth sin cambiar el diseño.
                  </p>
                </div>
                <div className="sideCard">
                  <p className="sideTitle">💡 Consejo</p>
                  <p className="sideText">
                    Usa un email real para poder recibir comunicaciones. Acento actual:{" "}
                    <strong style={{ color: accent }}>{accent}</strong>
                  </p>
                </div>
              </div>
            </div>

            <div style={{ height: 18 }} />
          </div>
        </div>
      </div>
    </>
  );
}
